import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
